import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import englishCareer from "../data/CdataEN";
import frenchCareer from "../data/CdataFR";

const CareerDetails = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const location = useLocation();
  const navigate = useNavigate();
  const currentCareerState = location.state;

  const [careers, setCareers] = useState(
    language === "fr" ? frenchCareer : englishCareer
  );

  const [currentCareer, setCurrentCareer] = useState(() => {
    const initialCareers = i18n.language === "fr" ? frenchCareer : englishCareer;
    return initialCareers.find(s => s.detailData.title === currentCareerState.title)?.detailData || currentCareerState;
  });

  useEffect(() => {
    const selectedCarrer = i18n.language === "fr" ? frenchCareer : englishCareer;
    setCareers(selectedCarrer);

    const translatedCareer = selectedCarrer.find(
      (s) => s.detailData.id === currentCareerState.id
    );

    if (translatedCareer) {
      setCurrentCareer(translatedCareer.detailData);
    } else {
      setCurrentCareer(currentCareerState);
    }
  }, [i18n.language, currentCareerState]);

  const handleNavigateToCareer = (detailData) => {
    navigate("/career-details", {
      state: detailData,
    });
  };

  // Get the other Careers (not the current one)
  const otherCareers = careers.filter(
    (career) => career.detailData.title !== currentCareer.title
  );

  return (
    <div className="container my-5">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <span></span>
        <div className="mt-5 text-center">
          <h5 className="mb-4">{t("exploreOtherOffers")}</h5>
          {otherCareers.map((career, index) => (
            <button
              key={index}
              className="btn blue-color-code  text-white m-2"
              onClick={() => handleNavigateToCareer(career.detailData)}
            >
              {career.title}
            </button>
          ))}
        </div>
      </div>

      <h1 className="mb-3 mt-3">{currentCareer.title}</h1>
      <h4
        className="mb-4 text-muted"
        dangerouslySetInnerHTML={{
          __html: currentCareer.subtitle.replace(/\n/g, "<br />"),
        }}
      ></h4>

      <div className="row">
        {currentCareer.sections.map((section, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <div className="card p-3 h-100 shadow-sm text-center">
              <div className="text-center mb-2">
                {section.image && (
                  <img
                    src={section.image}
                    alt={`${section.title} icon`}
                    style={{
                      width: "60px",
                      height: "50px",
                      marginBottom: "10px",
                    }}
                  />
                )}
              </div>
              <h5 className="mb-3">
                <strong>{section.title}</strong>
              </h5>
              <ul className="list-unstyled text-start">
                {section.points.map((point, i) => (
                  <li key={i}>• {point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* Email response button */}
      <div className="text-center mt-4">
  <ul className="list-unstyled mb-3">
    <li>📍 {t("careerDetails.location")}</li>
    <li>💼 {t("careerDetails.platform")}</li>
    <li>
      👉 {t("careerDetails.contact")}:{" "}
       <strong>recrutement@my-outsourcing.com</strong> 
    </li>
  </ul>

  <a
    href={`mailto:recrutement@my-outsourcing.com?subject=${t("emailSubject", {
      title: currentCareer.title,
    })}`}
    className="btn btn-primary"
  >
    {t("respondToJob")}
  </a>
</div>
    </div>
  );
};

export default CareerDetails;
